module.exports = __webpack_public_path__ + "static/media/flatbread-product-3.3ef2e43d.svg";